import { gql, useLazyQuery } from '@apollo/client'

export const GET_USER_INVITATION_VALID = gql`
  query UserInvitationValid($invitationToken: String!) {
    userInvitationValid(invitationToken: $invitationToken)
  }
`

export interface IUserInvitationValidResult {
  userInvitationValid: boolean
}

export const useGetUserInvitationValid = () => {
  const [getUserInvitationValid, { loading, error }] =
    useLazyQuery<IUserInvitationValidResult>(GET_USER_INVITATION_VALID, {
      fetchPolicy: 'network-only',
    })

  return { getUserInvitationValid, loading, error }
}
